import React, { useState, useEffect,useContext } from 'react';
import './information.css';
import DayPicker from 'react-day-picker';
import 'react-day-picker/lib/style.css';
import Navbar from '../layouts/navbar';
import Parse from 'parse';
import swal from 'sweetalert';
import { AuthContext } from '../../auth';
import {Redirect} from 'react-router-dom';

const UserInfo = () => {
    
    const handleDayClick = (day, { selected }) => {
        console.log(day);
        // console.log(state.notavailable);
        // let temp = state.notavailable.filter(ob => ob.toLocaleDateString() === day.toLocaleDateString());
        // console.log(temp.length);
        // if (!temp.length) {
        //     this.setState({
        //         selectedDay: selected ? undefined : day,
        //     });
        // }
    }

    const [name, setName] = useState("");
    const [gender, setGender] = useState("");
    const [phoneno, setPhoneno] = useState("");
    const [doctor, setDoctor] = useState("");
    const [date, setDate] = useState("");
    let [logedinuser, setLogedinuser] = useContext(AuthContext);
    
    
    const handleSubmit = (e) => {
        e.preventDefault();
        // console.log(e)
        // const f = () => {

        // }
        // f();
        const Offline = Parse.Object.extend('Offline');
        const offfline = new Offline();

        offfline.set("name", name);
        offfline.set("gender", gender);
        offfline.set("phoneno", phoneno);
        offfline.set("doctor", doctor);
        offfline.set("user",logedinuser);

        offfline.save()
            .then((data) => {
                console.log(data);
                swal("Addedd!", "Appointment added you will be soon contacted ", "success");
                setName("");
                setPhoneno("");
                // this.props.history.push('/familystories/route');
            }).catch((error) => {
                console.log(error);
                swal("Oops!", "Seems like we couldn't provide you a booking at the moment...Please try again in sometime", "error");
            })

    }

    return (
        
        <div>
            {(logedinuser == null) &&(<div>
                {swal("Oops!", "Please login to book an appointment")}
            </div>) &&(
                 <Redirect to={{
                     pathname:'/login',
                     re:'/offline'
                    }}/>
            )}
            <Navbar head="Book An Appointment" />
            <div className="container ofcnt">
                <div className="row">
                    <div className="col">
                        {/* <h2 className="display-5 mb-0 date">Date</h2>
                        <p className="text-muted">Choose an available date</p>
                        <DayPicker
                            // disabledDays={state.notavailable}
                            onDayClick={handleDayClick}
                            // selectedDays={state.selectedDay}
                        ></DayPicker> */}
                        {/* <p>
                            {this.state.selectedDay
                                ? this.state.selectedDay.toLocaleDateString()
                                : 'Please select a day 👻'}
                        </p> */}
                        {/* <h3 className="display-4 mb-0">Time</h3>
                        <p className="text-muted">Choose a suitable Time</p> */}
                        <h3 className="display-4 mb-0">Personal Details</h3>
                        <p className="text-muted">We promise to keep these anonymous</p>
                        <form onSubmit={handleSubmit}>
                            <div className="form-group">
                                <input type="text" value={name}
                                    onChange={e => setName(e.target.value)}
                                    className="form-control in" placeholder="name" required></input>
                            </div>
                            <div className="form-row">
                                <div className="col-6">
                                    <select required className="form-control" onChange={e => setGender(e.target.value)} >
                                        <option value="">Gender</option>
                                        <option value="male">Male</option>
                                        <option value="female">Female</option>
                                    </select>
                                </div>
                                <div className="col-6">
                                    <input type="date" className="form-control in" required></input>
                                </div>
                            </div>
                            <div className="form-group mt-2">
                                <input type="text"
                                    className="form-control in"
                                    value={phoneno}
                                    onChange={e => setPhoneno(e.target.value)}
                                    placeholder="Phone number"
                                    required></input>
                            </div>
                            <h3 className="display-4">Whom to Connect</h3>
                            <div className="col-6">
                                <select required className="doctform form-control" onChange={e => setDoctor(e.target.value)}>
                                    <option value="">Doctor Type</option>
                                    <option value="Psychiatrist">Psychiatrist</option>
                                    <option value="Psychologist">Psychologist</option>
                                </select>
                            </div>
                            <button type="submit" class="authbtn btn-primary  mt-4">Submit</button>
                        </form>
                    </div>
                </div>

            </div>
        </div>
    );
}

export default UserInfo;